// Cutting a role's checklist field into the items a meeting step ticks off.
//
// The field is Markdown, not a rich document: the editor stores "- [ ] Traiter
// les emails", and older imported roles store "[ ] Intégrer CESA" with no dash
// at all. Both live in the database today, so both are accepted here.
//
// 🔑 An item has no identifier — the whole checklist is one text column. Its
// position is therefore the only handle available, and it is what a meeting
// step stores to remember which boxes were ticked (REU04-D5).
// ⚠️ The cost is stated plainly: reordering a role's checklist while a meeting
// is running shifts the boxes already ticked in it. Reordering between two
// meetings costs nothing, since each meeting starts from a blank state.
//
// The template's own "[x]" is deliberately ignored. A checklist is a reminder
// of recurring actions "pas encore acquises par le rôle" (REU04-D4): the role
// holds what must be done, a meeting holds what was done that day.

export interface ChecklistItem {
  index: number
  text: string
}

// A line is an item when it carries a checkbox, with or without a list marker.
const ITEM_LINE = /^\s*(?:[-*]\s+)?\[[ xX]\]\s?(.*)$/

export function parseChecklistItems(markdown: string): ChecklistItem[] {
  if (!markdown) return []

  const items: ChecklistItem[] = []
  for (const line of markdown.split('\n')) {
    const match = line.match(ITEM_LINE)
    if (!match) continue
    items.push({ index: items.length, text: match[1].trim() })
  }
  return items
}
